import type { StrictPost } from '$lib/types'

export const meta: StrictPost = {
	title: 'PauseAI Statement',
	description: 'Sign the PauseAI Statement',
	date: '2025-05-19',
	slug: 'statement',
	categories: []
}
